import PropTypes from 'prop-types';
import React from 'react';
import imagePlaceholderEverad from '../../apps/everad/assets/img/global/noimage.png';
import imagePlaceholderRocket from '../../apps/rocket/assets/img/global/noimage.png';

const volatiles = {
	placeholder: process.env.CPA_ENV == 'everad' ? imagePlaceholderEverad : imagePlaceholderRocket
};

const PlaceholderedImage = ({ src, alt, className }) => {
	return (
		<div className={className}>
			<img src={src || ''} alt={alt} onError={e => (e.target.src = volatiles.placeholder)} />
		</div>
	);
};

PlaceholderedImage.propTypes = {
	src: PropTypes.string,
	alt: PropTypes.string,
	className: PropTypes.string
};

export default PlaceholderedImage;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/image-placeholdered.js